import { IS_MOBILE } from '../../constants';
import { getLocationPath } from '../../helpers';
import { routes } from '../../router';

const ResetPassStep2 = {
  render: async () => {
    return ``;
  },
  afterRender: async () => {
    const locationPath = getLocationPath();
    const state = {
      mode: 'PIN_STEP_1',
      nextHash: routes.close.hashPath,
    };

    if (IS_MOBILE) {
      window.parent.history.replaceState(state, null, routes.enterPwd.hashPath);
      window.parent.location.replace(locationPath + routes.enterPwd.hashPath);
    } else {
      window.opener.history.replaceState(state, null, routes.enterPwd.hashPath);
      window.opener.location.replace(locationPath + routes.enterPwd.hashPath);
      self.close();
    }
  },
};
export default ResetPassStep2;
